module.exports = __webpack_public_path__ + "img/icon_pro3.8639082f.jpg";